/* es6-map/implement */ function _(require, module, exports) {
    if (!require(360) /* ./is-implemented */()) {
        Object.defineProperty(require(316) /* es5-ext/global */, 'Map', { value: require(364) /* ./polyfill */, configurable: true, enumerable: false,
            writable: true });
    }
}
